import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { Col, Row } from 'react-bootstrap';
import { IDelivery, ISelectedImage } from '../Entities';
import ExternalImageFile from '../externalFiles/ExternalImageFile';
import openImage from '../ImageViewing';
import DeliveryFile from './DeliveryFile';

interface IProps {
    delivery: IDelivery;
    readOnly: boolean;
    user: any;
    onClickImage: (selectedImage: ISelectedImage, deliveryFileWasSelected: boolean) => void;
    deleteDeliveryFile: (fileReference: string) => void;
    annotateExternalDeliveryFile: (id: number) => void;
    annotateDeliveryFile: (id: number) => void;
}

const DeliveryFiles = (props: IProps) => {
    if (!props.delivery) {
        return <div></div>;
    }

    const { apiUrl } = window.appConfig;

    return (
        <div className="generated-plan-sketches">
            <Row>
                {props.delivery.stories &&
                    props.delivery.stories.map((storey, index) => (
                        <div key={'delivery-storey-' + index}>
                            {storey.sketchUpPlan2Ds && (
                                <div>
                                    {storey.sketchUpPlan2Ds.map((sketchUpPlan2D, index) => (
                                        <Col sm={4} key={'sketchUpPlan2D-storey-' + index}>
                                            <DeliveryFile
                                                storeyName={`${
                                                    storey.customStoreyName
                                                        ? storey.customStoreyName
                                                        : Translate(storey.storey)
                                                } ${Translate(
                                                    'plan-order/delivery/2d-files/title'
                                                )}`}
                                                filename={sketchUpPlan2D.filename}
                                                isLocked={props.readOnly}
                                                user={props.user}
                                                imageSource={`${apiUrl}/file/${sketchUpPlan2D.thumbnailReference}`}
                                                onClickImage={() =>
                                                    props.onClickImage(sketchUpPlan2D, true)
                                                }
                                                annotate={() =>
                                                    props.annotateDeliveryFile(
                                                        sketchUpPlan2D.deliveryFileId
                                                    )
                                                }
                                                delete={() =>
                                                    props.deleteDeliveryFile(
                                                        sketchUpPlan2D.fileReference
                                                    )
                                                }
                                            />
                                        </Col>
                                    ))}
                                </div>
                            )}
                            {storey.sketchUpPlan3Ds && (
                                <div>
                                    {storey.sketchUpPlan3Ds.map((sketchUpPlan3D, index) => (
                                        <Col sm={4} key={'sketchUpPlan3D-storey-' + index}>
                                            <DeliveryFile
                                                storeyName={`${
                                                    storey.customStoreyName
                                                        ? storey.customStoreyName
                                                        : Translate(storey.storey)
                                                } ${Translate(
                                                    'plan-order/delivery/3d-files/title'
                                                )}`}
                                                filename={sketchUpPlan3D.filename}
                                                isLocked={props.readOnly}
                                                user={props.user}
                                                imageSource={`${apiUrl}/file/${sketchUpPlan3D.thumbnailReference}`}
                                                onClickImage={() =>
                                                    props.onClickImage(sketchUpPlan3D, true)
                                                }
                                                annotate={() =>
                                                    props.annotateDeliveryFile(
                                                        sketchUpPlan3D.deliveryFileId
                                                    )
                                                }
                                                delete={() =>
                                                    props.deleteDeliveryFile(
                                                        sketchUpPlan3D.fileReference
                                                    )
                                                }
                                            />
                                        </Col>
                                    ))}
                                </div>
                            )}
                            {storey.roomSketcherPlan2Ds && (
                                <div>
                                    {storey.roomSketcherPlan2Ds.map((roomSketcherPlan2D, index) => (
                                        <Col sm={4} key={'roomSketcherPlan2D-storey-' + index}>
                                            <DeliveryFile
                                                storeyName={`${
                                                    storey.customStoreyName
                                                        ? storey.customStoreyName
                                                        : Translate(storey.storey)
                                                } ${Translate(
                                                    'plan-order/delivery/room-sketcher-2d-files/title'
                                                )}`}
                                                filename={roomSketcherPlan2D.filename}
                                                isLocked={props.readOnly}
                                                user={props.user}
                                                imageSource={`${apiUrl}/file/${roomSketcherPlan2D.thumbnailReference}`}
                                                onClickImage={() =>
                                                    props.onClickImage(roomSketcherPlan2D, true)
                                                }
                                                annotate={() =>
                                                    props.annotateDeliveryFile(
                                                        roomSketcherPlan2D.deliveryFileId
                                                    )
                                                }
                                                delete={() =>
                                                    props.deleteDeliveryFile(
                                                        roomSketcherPlan2D.fileReference
                                                    )
                                                }
                                            />
                                        </Col>
                                    ))}
                                </div>
                            )}
                            {storey.roomSketcherPlan3Ds && (
                                <div>
                                    {storey.roomSketcherPlan3Ds.map((roomSketcherPlan3D, index) => (
                                        <Col sm={4} key={'roomSketcherPlan3D-storey-' + index}>
                                            <DeliveryFile
                                                storeyName={`${
                                                    storey.customStoreyName
                                                        ? storey.customStoreyName
                                                        : Translate(storey.storey)
                                                } ${Translate(
                                                    'plan-order/delivery/room-sketcher-3d-files/title'
                                                )}`}
                                                filename={roomSketcherPlan3D.filename}
                                                isLocked={props.readOnly}
                                                user={props.user}
                                                imageSource={`${apiUrl}/file/${roomSketcherPlan3D.thumbnailReference}`}
                                                onClickImage={() =>
                                                    props.onClickImage(roomSketcherPlan3D, true)
                                                }
                                                annotate={() =>
                                                    props.annotateDeliveryFile(
                                                        roomSketcherPlan3D.deliveryFileId
                                                    )
                                                }
                                                delete={() =>
                                                    props.deleteDeliveryFile(
                                                        roomSketcherPlan3D.fileReference
                                                    )
                                                }
                                            />
                                        </Col>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                {props.delivery.externalDeliveryFiles.map((externalDeliveryFile, index) => (
                    <Col sm={4} key={'delivery-external-' + index}>
                        <ExternalImageFile
                            file={externalDeliveryFile}
                            readOnly={props.readOnly}
                            forAgent={false}
                            user={props.user}
                            onClick={() => openImage(externalDeliveryFile)}
                            onDelete={() =>
                                props.deleteDeliveryFile(externalDeliveryFile.fileReference)
                            }
                            onAnnotate={() =>
                                props.annotateExternalDeliveryFile(
                                    externalDeliveryFile.planOrderExternalFileId
                                )
                            }
                            downloadTranslationKey={
                                'order/plan/delivery/download-external-delivery-file'
                            }
                        />
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default DeliveryFiles;
